import angular from 'angular';

angular
  .module('cloudX')
  .controller('ConfirmChangesDialogCtrl', [
    '$scope',
    '$element',
    'appMessages',
    'close',
    'title',
    'message',
    'showSaveButton',
    confirmChangesDialogCtrl,
  ]);

function confirmChangesDialogCtrl(
  $scope,
  $element,
  appMessages,
  close,
  title,
  message,
  showSaveButton,
) {
  $scope.title = appMessages(title);
  $scope.message = appMessages(message);
  $scope.showSaveButton = showSaveButton;
  $scope.close = function(result) {
    close(result, 500);
  };
}
